var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableSettings"},[_c('PageSize',{staticClass:"TableSettings__pageSize"}),_c('LayoutSelection',{staticClass:"TableSettings__layouts"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }